// extracted by mini-css-extract-plugin
export default {"container":"FoodBlogShowcase_container__sqiCA"};